module.exports = __webpack_public_path__ + "static/media/Potregi.03bbd2e5.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Potregi.otf
// module id = 3504
// module chunks = 68